import React from 'react'
import { animateScroll as scroll } from 'react-scroll';

import {
    FooterContainer,
    FooterWrap,
    FooterLinksContainer,
    FooterLinksWrapper,
    FooterLinkItems,
    FooterLinkTitle,
    FooterLink,
    FooterLinkOutside,
    CopyrightContainer,
    CopyrightWebsite,
    CopyrightWrap,
    CopyrightLogo
} from './FooterElements'

const Footer = () => {

    const toggleHome = () => {
        scroll.scrollToTop();
    };

    return (
        <FooterContainer className="darkSecondaryBackground lightColor">
            <FooterWrap>
                <FooterLinksContainer>
                    <FooterLinksWrapper>
                        <FooterLinkItems className="lightColor">
                            <FooterLinkTitle>En savoir plus</FooterLinkTitle>
                            <FooterLink to="/about">Qui suis-je?</FooterLink>
                            <FooterLink to="/credits">Crédits</FooterLink>
                            <FooterLink to="/articles">Articles</FooterLink>
                        </FooterLinkItems>
                    </FooterLinksWrapper>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle>Réseaux sociaux</FooterLinkTitle>
                            <FooterLinkOutside href="https://www.linkedin.com/in/maeva-fortune" target="_blank">LinkedIn</FooterLinkOutside>
                            <FooterLinkOutside href="https://gitlab-ce.iut.u-bordeaux.fr/maefortune" target="_blank"> Gitlab</FooterLinkOutside>
                            <FooterLinkOutside href="mailto:fortunemaeva2001@gmail.com">Email</FooterLinkOutside>
                        </FooterLinkItems>
                    </FooterLinksWrapper>
                </FooterLinksContainer>
                <CopyrightContainer>
                    <CopyrightWrap>
                        <CopyrightLogo to='/' onClick={toggleHome}>MF</CopyrightLogo>
                        <CopyrightWebsite>© {new Date().getFullYear()} Maëva Fortune</CopyrightWebsite>
                    </CopyrightWrap>
                </CopyrightContainer>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer
